import {pageInfo,endQc} from '../api';
import {Message} from 'element-ui';
import {goodsCategory, plant} from "../../../../../api";

const start = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    endQcObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({
        ...item,
        toxinSampleAddrNameShowColor: item.toxinSampleAddrNo == '20' || undefined,
        goodsCategoryNameShowColor: true,
        goodsCategoryNameColor:  item.goodsCategoryCode == '10' ? 'blue' : 'red',
        btns: [true]
      }));
    },
    GOODS_CATEGORY(state, data) {
      state.goodsCategoryObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    END_QC(state, data){
      state.endQcObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async goodsCategory({commit}, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async endQc({commit}, obj){
      let result = await endQc(obj);
      commit('END_QC', result);
    }
  }
}
export default start



// WEBPACK FOOTER //
// ./src/page/bd/qc/end/store/end.store.js